import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Phone, X, ArrowRight } from "lucide-react";

const DISMISS_KEY = "hc_sms_prompt_dismissed_v1";

export default function SmsPromptCard({ user }) {
  const [smsStatus, setSmsStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    try { setDismissed(localStorage.getItem(DISMISS_KEY) === "1"); } catch (e) { /* noop */ }
    api.get("/me/sms-status").then((r) => setSmsStatus(r.data)).catch(() => { /* noop */ });
  }, []);

  if (dismissed || !smsStatus) return null;
  if (!smsStatus.twilio_configured) return null;          // hide if Twilio not connected
  if (smsStatus.phone_e164 && smsStatus.sms_opt_in) return null; // already opted in
  if (smsStatus.phone_e164 && smsStatus.phone_verified) return null; // already on it, will opt in from Settings

  const isPremium = user?.subscription_tier === "paid";

  const handleDismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch (e) { /* noop */ }
    setDismissed(true);
  };

  return (
    <div
      className="relative mb-6 rounded-2xl p-5 bg-gradient-to-br from-[#FDF6EC] via-[#FCFAF8] to-[#F3EFEA] border border-[#E8DCC8] shadow-sm"
      data-testid="sms-prompt-card"
    >
      <button
        onClick={handleDismiss}
        className="absolute top-3 right-3 text-[#7A736E] hover:text-[#3D3935] p-1 rounded-lg hover:bg-white/60"
        aria-label="Dismiss"
        data-testid="sms-prompt-dismiss"
      >
        <X className="w-4 h-4" />
      </button>

      <div className="flex flex-col sm:flex-row items-start gap-4 sm:items-center pr-8">
        <div className="w-12 h-12 rounded-2xl bg-[#3A5A4A] flex items-center justify-center flex-shrink-0">
          <Phone className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-lg text-[#3D3935]">Never miss a medication or appointment again</h3>
          <p className="text-sm text-[#7A736E] mt-1">
            {isPremium ? (
              <>Add your phone number and we&apos;ll text you appointment reminders, medication times, and tasks due today. You pick exactly what you want notified about — opt out anytime.</>
            ) : (
              <>SMS reminders are a Premium feature. Add your number now and turn them on the moment you upgrade.</>
            )}
          </p>
        </div>
        <Link
          to="/settings"
          className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-[#3A5A4A] hover:bg-[#2C4538] text-white text-sm font-medium transition flex-shrink-0 whitespace-nowrap"
          data-testid="sms-prompt-add-phone"
        >
          Add my phone <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
